export interface SelectionState {
  selectedHomeId: string | null;
  selectedRoomId: string | null;
  selectedDeviceId: string | null;
  selectedGatewayId: string | null;
  photoUrlByHome: Record<string, string>;
  roomsByHome: Record<string, any[]>;
}

export const initialSelectionState = (): SelectionState => ({
  selectedHomeId: null,
  selectedRoomId: null,
  selectedDeviceId: null,
  selectedGatewayId: null,
  photoUrlByHome: {},
  roomsByHome: {},
});

export default {
  setSelectedHomeId(state: SelectionState, homeId: string | null){
    state.selectedHomeId = homeId;
  },
  setSelectedRoomId(state: SelectionState, roomId: string | null){
    state.selectedRoomId = roomId;
  },
  setSelectedDeviceId(state: SelectionState, deviceId: string | null){
    state.selectedDeviceId = deviceId;
  },
  setSelectedGatewayId(state: SelectionState, gatewayId: string | null){
    state.selectedGatewayId = gatewayId;
  },

  reset(state: SelectionState){
    state.selectedHomeId = null;
    state.selectedRoomId = null;
    state.selectedDeviceId = null;
    state.selectedGatewayId = null;
  },

  setPhotoUrlForHome(state: SelectionState, { homeUid, photoUrl }: { homeUid: string; photoUrl: string }){
    state.photoUrlByHome = { ...state.photoUrlByHome, [homeUid]: photoUrl };
  },
  setRoomsForHome(state: SelectionState, { homeUid, rooms }: { homeUid: string; rooms: any[] }){
    state.roomsByHome = { ...state.roomsByHome, [homeUid]: rooms };
  },
};
